import React from 'react';

function Checkbox(props: { status: boolean; flip: any; disabled?: boolean }) {
  return props.status ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
      onClick={props.disabled ? () => {} : props.flip}
      style={{ opacity: props.disabled ? 0.4 : 1, marginTop: '-9px' }}
    >
      <g fill="none" fillRule="evenodd">
        <rect width="16" height="16" fill="#415859" rx="2" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M4.422 7.335L3 8.771 6.788 12 13 5.268 11.403 4 6.607 9.198z"
        />
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      onClick={props.disabled ? () => {} : props.flip}
      style={{ opacity: props.disabled ? 0.4 : 1, marginTop: '-9px' }}
    >
      <rect
        width="16"
        height="16"
        fill="white"
        fillRule="evenodd"
        stroke="#415859"
        rx="2"
        transform="translate(1 1)"
      />
    </svg>
  );
}

export default Checkbox;
